import React, {
  useEffect, useRef, useState, useContext,
} from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass';
import { FiPlus, FiMinus } from 'react-icons/fi';
import styled, { ThemeContext } from 'styled-components';
import theme from 'styled-theming';
import { useClickAway } from 'react-use';
import DropDownCard from './dropdown-card';
import { Button } from '../..';
import { ReactComponent as SelectCaretComponent } from '../../../assets/select-caret.svg';

const PlusIcon = styled(FiPlus)`
  stroke-width: 3px;
`;

const ButtonDropdown = (props) => {
  const { children, data, ...otherProps } = props;
  const [open, setOpen] = useState(false);
  const drop = useRef(null);
  const isMounted = useRef(false);
  const themeContext = useContext(ThemeContext);

  useClickAway(drop, () => {
    if (isMounted.current) {
      setOpen(false);
    }
  });

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <Box
      ref={drop}
      style={{
        position: 'relative',
        width: 'auto',
        display: 'inline-block',
      }}
    >
      <Button
        smallSized
        variant="tertiary"
        mt={2}
        mb={3}
        onClick={() => setOpen((prevState) => !prevState)}
        style={{ border: open ? `1px solid ${themeContext.mode === 'dark' ? themeContext.colors.white : themeContext.colors.deepGrey}` : '1px solid transparent' }}
      >
        <Flex alignItems="center">
          <PlusIcon size={12} />
          <Text fontSize={0} fontWeight={500} mx={2}>Add from template</Text>
          <SelectCaretComponent />
        </Flex>
      </Button>
      {open && <DropDownCard data={data} setOpen={setOpen} />}
    </Box>
  );
};

ButtonDropdown.defaultProps = {
  children: null,
  data: [],
};

ButtonDropdown.propTypes = {
  children: PropTypes.node,
  data: PropTypes.array,
};

export default ButtonDropdown;
